import { render, staticRenderFns } from "./CartPageEmptyContent.vue?vue&type=template&id=52672efb&scoped=true"
import script from "./CartPageEmptyContent.vue?vue&type=script&lang=js"
export * from "./CartPageEmptyContent.vue?vue&type=script&lang=js"
import style0 from "./CartPageEmptyContent.vue?vue&type=style&index=0&id=52672efb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52672efb",
  null
  
)

export default component.exports